import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import _ from 'lodash';
import Employee from 'src/models/AP/Employee';

interface ITSDIEmployeesDialogProps {
    dialogName: string;
    handleSelectedEmployee?: (employee: Employee) => void;
    hideDialog: () => void;
}

const employees = [
    { id: 1, name: 'Amanda Sansone', tsdNo: 5502 }, 
    { id: 2, name: 'Annika Elliot', tsdNo: 5334 }, 
    { id: 3, name: 'Blake Thomas', tsdNo: 6685 }, 
    { id: 4, name: 'Brandon Dodds', tsdNo: 5561 },
    { id: 5, name: 'Brandon Ward', tsdNo: 6195 }, 
    { id: 6, name: 'Brendan Bryan', tsdNo: 6668 }, 
    { id: 7, name: 'Brent Broussard', tsdNo: 1034 }, 
];

const TSDIEmployeesDialog = (props: ITSDIEmployeesDialogProps) => {
    const { register, errors, getValues } = useForm();
    const [selectedEmployee, setSelectedEmployee] = useState<Employee>(undefined);
    const [employeeList, setEmployeeList] = useState<Array<Employee>>(undefined); // The whole personnel list
    const [employeeSearchResults, setEmployeeSearchResults] = useState<Array<Employee>>(undefined); // The personnel filtered by search (Name)

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        setEmployeeList(employees);
        setEmployeeSearchResults(employees);
        console.log('TSDIEmployeesDialog onCreate()');
    };

    const OKClicked = () => {
        let values = getValues();
        console.log(values);

        props.handleSelectedEmployee(selectedEmployee);
        props.hideDialog();
    };

    const search = _.debounce(() => {
        let searchName = getValues('search');

        let employeeResults = employeeList;
        if (searchName?.length) {
            searchName = searchName?.toLowerCase();

            console.log(searchName);
            employeeResults = employeeResults?.filter(employee => employee.name.toLowerCase().includes(searchName) || employee.tsdNo.toString().includes(searchName));
        } 
        setEmployeeSearchResults(employeeResults);

    }, 800);

    return (
        <Dialog title="TSDI Employees" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '40%' }}>
                <RHFInputBox 
                    labelOnLeft={true} 
                    labelStyle={{ marginTop: '1.5rem' }} 
                    label="Find" 
                    name={'search'} 
                    register={register}
                    errors={errors}
                    style={{ width: '50%', marginTop: '1rem' }}
                    bodyStyle={{ marginLeft: '25%' }}
                    onChange={() => search()}
                />
                <div style={{marginTop: '3rem', overflowY: 'scroll', height: '20rem'}}>
                    <form>
                        <table style={{ width: '100%' }}>
                            <thead style={{ textAlign: 'left' }}>
                                <tr>
                                    <th>Name</th>
                                    <th>TSD_No</th>
                                </tr>
                            </thead>
                            {employeeSearchResults?.map((employee: Employee, index: number) => {
                                return (
                                    <tbody key={employee.id}>
                                        <tr 
                                            className="table-item-hover" 
                                            style={ employee?.id === selectedEmployee?.id ? { background: 'yellow', textAlign: 'left' } : {textAlign: 'left'}} 
                                            onClick={() => setSelectedEmployee(employee)}
                                        >
                                            <td style={{ width: '80%' }}>
                                                <label>{employee.name}</label>
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                <label>{employee.tsdNo}</label>
                                            </td>
                                        </tr>
                                    </tbody>
                                    );
                                })}
                        </table>
                    </form>
                </div>
                <div className="form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                    <Button
                        className="blue-hover-button"
                        style={{ width: '20%', marginRight: '1rem' }}
                        text={'Find'}
                        onClick={() => OKClicked()}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '20%', marginRight: '1rem' }}
                        text={'OK'}
                        onClick={() => OKClicked()}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '20%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => props.hideDialog()}
                    />
                </div>
        </Dialog>
    );
};

export default TSDIEmployeesDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/TSDIEmployeesDialog.tsx